// 导入所有 coupon 模块的国际化文件
import { messages as couponMessages } from '@/lang/coupon/couponLang.js'

// 合并所有国际化消息
export const messages = {
    en: {
        ...couponMessages.en
    },
    zh: {
        ...couponMessages.zh
    }
}

